import { useCharacterHomeCharacter, useCharacterHomeItemComparisons } from '../../components/CharacterHomeItemTransfer';
import { countOccupiedSlots } from './count-occupied-slots';
import { InlayPanel, ItemGrid, useItemTransferContext } from '@sorrem-client/ui/components';
import { useCallback } from 'react';
import { toTourTargetProps } from '@sorrem-client/ui/shared/tour-targets';

export function InventoryStoragePanel(): JSX.Element | null {
    const contextPlayer = useCharacterHomeCharacter();
    const itemComparisons = useCharacterHomeItemComparisons(contextPlayer);
    const { selectedItemId, clearSelectedItem, moveTo } = useItemTransferContext();

    const handleRearrange = useCallback((event: { toIndex: number }): void => {
        moveTo('storage', event.toIndex);
    }, [moveTo]);

    if (contextPlayer === null) {
        return null;
    }

    return (
        <InlayPanel label={`Storage cache (${countOccupiedSlots(contextPlayer.storedItems)} / ${contextPlayer.maxStoredSlots})`} {...toTourTargetProps('storage')}>
            <ItemGrid
                totalSlots={contextPlayer.maxStoredSlots}
                items={contextPlayer.storedItems}
                itemComparisons={itemComparisons}
                container='storage'
                size='large'
                selectedItemId={selectedItemId}
                onRearrangeItems={handleRearrange}
                onDeselectSelectedItem={clearSelectedItem}
                ariaLabel='Storage panel'
            />
        </InlayPanel>
    );
}
